'use strict';

import TextView from 'views/record/subfields/Text';
import intlTelInput from 'intl-tel-input';
import DeviceUtils from 'utils/DeviceUtils';

class PhoneField extends TextView{

    onDOMUpdated () {
        super.onDOMUpdated();

        this.phoneEl = this.$el.find('.phoneInput');
        if(this.phoneEl.length > 0) {
            this.iti = window.intlTelInput(this.phoneEl[0], {
                autoFormat: true,
                initialCountry: 'ch',
                preferredCountries: ['ch', 'de', 'fr'],
                formatOnDisplay: true,
                separateDialCode: true,
                autoPlaceholder: 'off'
            });
            this.phoneEl.on('countrychange', () => {
                this.onPhoneNumberChange();
            });
            var me = this;
            this.phoneEl.on('change', () => {
                var number = me.phoneEl.val();
                var classf = me.$el.find('.iti__selected-flag > .iti__flag').attr('class');
                var flag = classf.slice(-2);
                var formattedNumber = window.intlTelInputUtils.formatNumber(number, flag, window.intlTelInputUtils.numberFormat.NATIONAL);
                me.phoneEl.val(formattedNumber);
                this.setPhoneLink();
            });
            this.setPhoneLink();
        }
        this.fixFlagPosition();
    }

    setPhoneLink() {
        var number = this.phoneEl.val();
        if(!number) {
            this.$el.find('a.input-group-addon').removeAttr('href');
            return;
        }
        var classf = this.$el.find('.iti__selected-flag > .iti__flag').attr('class');
        var flag = classf.slice(-2);
        var formattedNumber = window.intlTelInputUtils.formatNumber(number, flag, window.intlTelInputUtils.numberFormat.INTERNATIONAL);
        this.$el.find('a.input-group-addon').attr('href', 'tel:' + formattedNumber)
    }

    onPhoneNumberChange() {
        this.setModelValue(this.iti.getNumber());
    }

    getFieldElement() {
        return this.$el.find('.phoneInput');
    }

    fixFlagPosition() {
        if(!DeviceUtils.isMobile()) {
            var marginLeft = this.getFieldElement().css('margin-left');
            this.$el.find('.iti__flag-container').css('margin-left', marginLeft);
        }
    }
}

export default PhoneField;
